<template>
  <NavigationLayout :padding="true">
    <SplitLayout
      :route-param="routeParam"
      :query-param-map="queryParamMap"
      :route-component="components.routeComponent">
      <Table
        :config="config"
        :data="customers"
        @row-selected="rowSelected">
        <template slot="controls">
          <vk-icon-button
            :href="createNewObjectLink"
            ratio="0.85"
            icon="plus"
          />
        </template>
      </Table>
    </SplitLayout>
  </NavigationLayout>
</template>

<script>
  import NavigationLayout from '../../components/layout/NavigationLayout'
  import SplitLayout from '../../components/layout/SplitLayout'
  import Customer from '../../views/customers/Customer'
  import SplitViewMixin from '../../mixins/split-view'
  import Domain from '../../views/web/Domain'
  import Server from '../../views/web/Server'
  import Table from '../../components/global/Table'
  import Page from '../../views/web/Page'
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        customers: 'customer/customers'
      })
    },
    data() {
      return {
        config: null,
      }
    },
    created() {
      this.setup('customers', 'customerId', Customer, {
        serverId: Server,
        domainId: Domain,
        pageId: Page,
      })
      this.config = this.createTableConfig('nav.customers', 'customers.no_customers_found')

      // Load Customers
      this.loading = true
      this.$store.dispatch('customer/loadCustomers', {
        appId: this.$route.params.appId
      }).finally(() => this.loading = false)
    },
    mixins: [
      SplitViewMixin
    ],
    components: {
      Table,
      SplitLayout,
      NavigationLayout
    }
  }
</script>